import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=e1cce524&scoped=true&"
import script from "./insert.vue?vue&type=script&lang=js&"
export * from "./insert.vue?vue&type=script&lang=js&"
import style0 from "./insert.vue?vue&type=style&index=0&id=e1cce524&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cce524",
  null
  
)

export default component.exports